import { Copy } from 'lucide-react';
import * as z from 'zod';

import type { InputProps } from '@/_components';
import { FormControl, FormItem, FormMessage, Input } from '@/_components';
import { snackbar, useCopyToClipboard } from '@/_shared';

import { ActionButton } from '../../actions';

export const FormInputEmail = ({
  ref,
  formItemClassName,
  value,
  className,
  ...props
}: InputProps & { formItemClassName?: string }) => {
  const { copy } = useCopyToClipboard();
  const handleOpen = () => {
    if (props.disabled && value) {
      if (
        z
          .string()
          .email()
          .safeParse(value as string).success
      ) {
        window.open(`mailto:${value}`, '_blank');
      } else {
        snackbar.error("Invalid email, couldn't open email client");
      }
    }
  };

  return (
    <FormItem className={formItemClassName}>
      <FormControl>
        <Input
          {...props}
          containerProps={{
            onClick: handleOpen,
            className: props.disabled && Boolean(value) ? 'cursor-pointer group' : '',
          }}
          className={`${className} decoration-primary decoration-2 disabled:pointer-events-none group-hover:disabled:underline`}
          type="email"
          value={value}
          ref={ref}
          postSlot={
            <ActionButton
              title={`Copy ${props.label}`}
              disabled={!value}
              icon={Copy}
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                if (value) {
                  copy(value as string);
                  snackbar.success(`${value} has been copied to clipboard`);
                }
              }}
            />
          }
        />
      </FormControl>
      <FormMessage />
    </FormItem>
  );
};
